import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';
import { OperatorCardSkeleton } from '@/modules/services/components/operator-card';
function SelectOperatorStepSkeleton() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-6 w-full max-w-24 lg:h-5.5 lg:max-w-28" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-2">{t0}<div className="flex flex-col gap-1"><Skeleton className="h-4.5 w-full lg:h-5.5" /><Skeleton className="h-4.5 w-full max-w-4/5 lg:h-5.5" /><Skeleton className="h-4.5 w-full max-w-3/4 lg:h-5.5" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-6 md:gap-8">{t1}<div className="grid w-full grid-cols-1 gap-6 md:grid-cols-2"><OperatorCardSkeleton /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export { SelectOperatorStepSkeleton };